export default __webpack_public_path__ + "static/media/image_2.1d18cc93.jpeg";